(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["24seven-collections"] && !Shopify.designMode) return;
  try {
    
(() => {
  const init = root => {
    if (root.dataset.carouselReady) return;
    root.dataset.carouselReady = 'true';
    const track = root.querySelector('.seven-collections__grid');
    const play = root.querySelector('[data-carousel-play]');
    const motion = matchMedia('(prefers-reduced-motion: reduce)');
    let playing = !motion.matches, hovered = false, focused = false, visible = false, timer, frame = 0;
    let automaticDirection = 1;
    const stopGlide = () => {
      cancelAnimationFrame(frame);
      frame = 0;
      track.classList.remove('is-gliding');
    };
    const glideTo = left => {
      stopGlide();
      if (motion.matches) { track.scrollTo({left, behavior: 'instant'}); return; }
      const start = track.scrollLeft;
      const started = performance.now();
      track.classList.add('is-gliding');
      const animate = now => {
        const progress = Math.min(1, (now - started) / 900);
        const ease = progress < .5 ? 4 * progress ** 3 : 1 - (-2 * progress + 2) ** 3 / 2;
        track.scrollTo({left: start + (left - start) * ease, behavior: 'instant'});
        if (progress < 1) frame = requestAnimationFrame(animate);
        else stopGlide();
      };
      frame = requestAnimationFrame(animate);
    };
    const step = direction => {
      const items = Array.from(track.children);
      if (!items.length) return;
      const max = track.scrollWidth - track.clientWidth;
      const stride = items.length > 1 ? items[1].offsetLeft - items[0].offsetLeft : items[0].clientWidth;
      let left = track.scrollLeft + direction * stride;
      if (direction > 0 && track.scrollLeft >= max - 3) left = 0;
      if (direction < 0 && track.scrollLeft <= 3) left = max;
      glideTo(Math.max(0, Math.min(max, left)));
    };
    const update = () => {
      clearInterval(timer);
      play.textContent = playing ? 'Pausar' : 'Reproducir';
      play.setAttribute('aria-label', playing ? 'Pausar avance automático' : 'Reproducir avance automático');
      if (playing && !hovered && !focused && visible && !document.hidden) timer = setInterval(() => {
        const max = track.scrollWidth - track.clientWidth;
        if (track.scrollLeft >= max - 3) automaticDirection = -1;
        else if (track.scrollLeft <= 3) automaticDirection = 1;
        step(automaticDirection);
      }, 4500);
    };
    root.querySelector('[data-carousel-prev]').addEventListener('click', () => { step(-1); update(); });
    root.querySelector('[data-carousel-next]').addEventListener('click', () => { step(1); update(); });
    play.addEventListener('click', () => { playing = !playing; if (!playing) stopGlide(); update(); });
    track.addEventListener('pointerdown', () => { stopGlide(); update(); }, {passive: true});
    track.addEventListener('wheel', () => { stopGlide(); update(); }, {passive: true});
    root.addEventListener('pointerenter', event => { if (event.pointerType === 'mouse') { hovered = true; update(); } });
    root.addEventListener('pointerleave', () => { hovered = false; update(); });
    root.addEventListener('focusin', () => { focused = true; update(); });
    root.addEventListener('focusout', event => { focused = root.contains(event.relatedTarget); update(); });
    document.addEventListener('visibilitychange', () => { if (document.hidden) stopGlide(); update(); });
    motion.addEventListener('change', () => { stopGlide(); playing = !motion.matches; update(); });
    new IntersectionObserver(entries => { visible = entries[0].isIntersecting; if (!visible) stopGlide(); update(); }, {threshold: .15}).observe(root);
    update();
  };
  const scan = () => document.querySelectorAll('[data-seven-carousel]').forEach(init);
  scan();
  document.addEventListener('shopify:section:load', scan);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["24seven-home"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('seven-home-media')) {
  customElements.define('seven-home-media', class extends HTMLElement {
    connectedCallback() {
      queueMicrotask(() => {
        if (!this.isConnected || this.controller) return;
        const video = this.querySelector('video');
        const button = this.querySelector('button');
        if (!video || !button) return;
        this.controller = new AbortController();
        const signal = this.controller.signal;
        const update = () => {
          const label = video.paused ? button.dataset.playLabel : button.dataset.pauseLabel;
          button.textContent = label;
          button.setAttribute('aria-label', label);
        };
        button.hidden = false;
        video.defaultMuted = true;
        video.muted = true;
        video.autoplay = true;
        video.playsInline = true;
        let userPaused = false;
        let visible = true;
        const syncPlayback = () => {
          if (!visible || document.hidden || userPaused) video.pause();
          else video.play().catch(update);
        };
        this.mediaObserver = new IntersectionObserver(entries => {
          visible = entries[0].isIntersecting;
          syncPlayback();
        }, { threshold: .05 });
        this.mediaObserver.observe(this);
        document.addEventListener('visibilitychange', syncPlayback, { signal });
        syncPlayback();
        button.addEventListener('click', () => {
          userPaused = !video.paused;
          syncPlayback();
        }, { signal });
        video.addEventListener('play', update, { signal });
        video.addEventListener('pause', update, { signal });
        update();
      });
    }
    disconnectedCallback() {
      this.mediaObserver?.disconnect();
      this.mediaObserver = null;
      this.querySelector('video')?.pause();
      this.controller?.abort();
      this.controller = null;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["seven-catalog"] && !Shopify.designMode) return;
  try {
    
(() => {
  const normalize = value => value.normalize('NFD').replace(/[\u0300-\u036f]/g,'').toLocaleLowerCase('es').trim();
  const initialize = () => document.querySelectorAll('.seven-catalog').forEach(catalog => {
    const search = catalog.querySelector('input[type="search"]');
    if (!search || search.dataset.catalogReady) return;
    search.dataset.catalogReady = 'true';
    const cards = Array.from(catalog.querySelectorAll('[data-catalog-title]'));
    const count = catalog.querySelector('.seven-catalog__count');
    const initialCount = count.textContent;
    search.addEventListener('input', () => {
      const terms = normalize(search.value).split(/\s+/).filter(Boolean);
      let visible = 0;
      cards.forEach(card => {
        card.hidden = !terms.every(term => normalize(card.dataset.catalogTitle).includes(term));
        if (!card.hidden) visible++;
      });
      count.textContent = terms.length ? `${visible} ${visible === 1 ? 'colección encontrada' : 'colecciones encontradas'}` : initialCount;
      catalog.querySelector('.seven-catalog__empty').hidden = visible !== 0;
    });
  });
  initialize();
  document.addEventListener('shopify:section:load', initialize);
})();

  } catch(e) { console.error(e); }
})();
})();
